import * as Sentry from "@sentry/react";

const DSN = process.env.REACT_APP_SENTRY_DSN;

export function initSentry() {
  if (!DSN) return; // no-op when DSN is empty (dev / not configured yet)
  Sentry.init({
    dsn: DSN,
    tracesSampleRate: 0.1,
    environment: process.env.NODE_ENV || "production",
  });
}

export const captureError = (err, ctx) => {
  if (DSN) Sentry.captureException(err, { extra: ctx });
  else if (typeof console !== "undefined") console.error(err, ctx);
};
